import reportError from 'ha/helpers/bugsnag/reportError';

export default function hotjarMiddleware(/* state */) {
  return next => action => {
    next(action);

    if (global.hj) {
      if (action.meta && action.meta.hotjar) {
        try {
          global.hj(action.meta.hotjar.type, action.meta.hotjar.payload);
        } catch (err) {
          reportError('something went wrong with hj', { metaData: err });
        }
      }
    }
  };
}
